"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceTabs = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var CenteredContainer_1 = require("@nerdwallet/currency/components/CenteredContainer");
var Text_1 = require("@nerdwallet/currency/components/Text");
var nerdwallet_plus_logo_1 = require("../nerdwallet-plus-logo");
var marketplace_tabs_module_css_1 = __importDefault(require("./marketplace-tabs.module.css"));
var AnimateOpacity = function (_a) {
    var _b;
    var children = _a.children, visible = _a.visible;
    var _c = (0, react_1.useState)(visible), isAnimating = _c[0], setIsAnimating = _c[1];
    (0, react_1.useEffect)(function () {
        setTimeout(function () {
            setIsAnimating(visible);
        }, 200);
    }, [visible]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(marketplace_tabs_module_css_1.default.animateOpacity, (_b = {},
            _b[marketplace_tabs_module_css_1.default.animateOpacityVisible] = visible,
            _b[marketplace_tabs_module_css_1.default.animateOpacityIn] = isAnimating,
            _b)) }, children));
};
var MarketplaceTabs = function (_a) {
    var _b;
    var iconImageHeight = _a.iconImageHeight, iconImageWidth = _a.iconImageWidth, iconImageHeightMobile = _a.iconImageHeightMobile, iconImageWidthMobile = _a.iconImageWidthMobile, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, _d = _a.sections, sections = _d === void 0 ? [] : _d, _e = _a.size, size = _e === void 0 ? "" : _e;
    var stickyHeaderRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), stickyToTop = _f[0], setStickyToTop = _f[1];
    var _g = (0, react_1.useState)(0), activeIndex = _g[0], setActiveIndex = _g[1];
    var onScroll = function () {
        var _a;
        var clientRect = (_a = stickyHeaderRef === null || stickyHeaderRef === void 0 ? void 0 : stickyHeaderRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var shouldStickyOnTop = clientRect ? (clientRect === null || clientRect === void 0 ? void 0 : clientRect.top) <= 0 : false;
        setStickyToTop(shouldStickyOnTop);
    };
    var onTabChangeHandler = (0, react_1.useCallback)(function (index, tab) {
        if (activeIndex !== index) {
            onChange(index, tab);
        }
        setActiveIndex(index);
    }, [activeIndex]);
    (0, react_1.useEffect)(function () {
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", onScroll);
            return function () { return window.removeEventListener("scroll", onScroll); };
        }
    }, []);
    // Sticky header should have a higher z-index, this makes editor panel tab hidden
    (0, react_1.useEffect)(function () {
        var stickyHeaderControl = document.querySelector("div.editor-control__type.editor-control__type__stickyheaderv2");
        if (stickyHeaderControl) {
            // if panel tab is in the page we make it visible over sticky header
            stickyHeaderControl.style.zIndex = "102";
        }
    }, []);
    var dimensions = (0, react_1.useMemo)(function () {
        return size === "lg"
            ? { width: iconImageWidth, height: iconImageHeight }
            : { width: iconImageWidthMobile, height: iconImageHeightMobile };
    }, [
        iconImageHeight,
        iconImageHeightMobile,
        iconImageWidth,
        iconImageWidthMobile,
        size,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { ref: stickyHeaderRef, id: "sticky-header-v2", "data-testid": "sticky-header-v2", className: (0, classnames_1.default)([
                marketplace_tabs_module_css_1.default.stickyHeader,
                (_b = {},
                    _b[marketplace_tabs_module_css_1.default.disableDropShadow] = !stickyToTop,
                    _b),
            ]) },
            react_1.default.createElement(CenteredContainer_1.CenteredContainer, { className: marketplace_tabs_module_css_1.default.stickyHeaderItems, "data-testid": "centered-container-sticky-header-items-container" },
                react_1.default.createElement("div", { className: marketplace_tabs_module_css_1.default.icon },
                    react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { logoColor: "green-darkest", small: true, height: dimensions.height, width: dimensions.width })), sections === null || sections === void 0 ? void 0 :
                sections.map(function (item, index) {
                    var _a;
                    var _b;
                    return (react_1.default.createElement(Box_1.Box, { key: index, id: (_b = item === null || item === void 0 ? void 0 : item.id) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.name, className: (0, classnames_1.default)(marketplace_tabs_module_css_1.default.stickyHeaderButtonItem, (_a = {},
                            _a[marketplace_tabs_module_css_1.default.activeLink] = index === activeIndex,
                            _a)), onClick: function () { return onTabChangeHandler(index, item); } },
                        react_1.default.createElement(Text_1.Text, { bold: true, size: "x-small", component: "a" }, item === null || item === void 0 ? void 0 : item.name)));
                }))),
        react_1.default.createElement(CenteredContainer_1.CenteredContainer, { "data-testid": "centered-container-sticky-header-items-container" }, sections === null || sections === void 0 ? void 0 : sections.map(function (item, i) { return (react_1.default.createElement(AnimateOpacity, { key: i, visible: activeIndex === i }, item.content)); }))));
};
exports.MarketplaceTabs = MarketplaceTabs;
exports.default = exports.MarketplaceTabs;
